const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const assetUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const webpUrl = (u) => {
  if (!u || !/^\/api\/images\//.test(u) || !/\.(jpe?g|png)$/i.test(u)) return null;
  return assetUrl(u.replace(/\.(jpe?g|png)$/i, ".webp"));
};

async function get(path, optional = false) {
  const res = await fetch(`${API}${path}`);
  if (optional && res.status === 404) return null;
  if (!res.ok) throw new Error(`GET ${path} failed`);
  return res.json();
}

async function safeGet(path, fallback, optional = false) {
  try {
    return await get(path, optional);
  } catch {
    return fallback;
  }
}

export async function fetchSite() {
  const [summit, facts, timeline, sectionPhotos, settings] = await Promise.all([
    safeGet("/summit", null, true),
    safeGet("/facts", []),
    safeGet("/timeline", []),
    safeGet("/section_photos", null),
    safeGet("/settings", null),
  ]);
  return { summit, facts, timeline, sectionPhotos, settings };
}

export async function submitJoin(data) {
  const res = await fetch(`${API}/join`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Join failed");
  return res.json();
}
